import React  from 'react';

const Payment = () => {

    return (
        <div>
            
            <h3>payment system coming soon!!!</h3>

         
        </div>
    );
};

export default Payment;